import { createFileRoute } from '@tanstack/react-router'
import EmailTemplatesPage from '@/spa/pages/EmailTemplatesPage'
import { routeErrorComponent } from './_shared/RouteError'

export const Route = createFileRoute('/email-templates')({
  component: EmailTemplatesPage,
  errorComponent: routeErrorComponent,
})
